var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyMomentStarIcon = function SvgKeyMomentStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.834 7.503a1.15 1.15 0 0 0-1.078-.764h-4.653a.38.38 0 0 1-.36-.252L11.079 1.75a1.16 1.16 0 0 0-1.077-.726 1.14 1.14 0 0 0-1.07.764L7.258 6.502a.38.38 0 0 1-.36.253H2.246a1.15 1.15 0 0 0-1.077.764 1.16 1.16 0 0 0 .344 1.26l3.958 3.286a.38.38 0 0 1 .122.413l-1.666 4.99a1.146 1.146 0 0 0 1.765 1.29l4.08-2.995a.374.374 0 0 1 .451 0l4.088 2.996a1.147 1.147 0 0 0 1.804-1.292l-1.666-4.99a.38.38 0 0 1 .122-.412l3.966-3.293a1.15 1.15 0 0 0 .298-1.269z"
  })));
};
export { SvgKeyMomentStarIcon as ReactComponent };